import PropTypes from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Button, Icon, Table } from "semantic-ui-react";
import { isNil } from "../../../../libs/common_utils";
import DeletePermissionModal from "../delete-permission-modal";

const ProductPermissionsSubgrid = ({ permissionRows }) => {
  const intl = useIntl();
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const openDeleteDialog = (permission) => {
    setSelectedPermission(permission);
    setShowDeleteDialog(true);
  };

  const closeDeleteDialog = () => {
    setSelectedPermission(null);
    setShowDeleteDialog(false);
  };

  const renderSellers = (sellerIds) => {
    if (sellerIds.length === 0) {
      return intl.formatMessage({ id: "LABEL_ALL_SELLERS", defaultMessage: "All Sellers" });
    }
    if (sellerIds.length === 1 && sellerIds[0] === "0") {
      return "1P";
    }
    return sellerIds.join("\n ");
  };

  return (
    <>
      <Table className="custom-table">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {intl.formatMessage({
                defaultMessage: "Advertisers",
                id: "LABEL_ADVERTISERS",
              })}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {intl.formatMessage({
                defaultMessage: "Sellers",
                id: "LABEL_SELLERS",
              })}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {intl.formatMessage({
                defaultMessage: "Brands",
                id: "LABEL_BRANDS",
              })}
            </Table.HeaderCell>
            <Table.HeaderCell collapsing />
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {permissionRows.map((row) => {
            const { advertisers, seller_ids, brands, id } = row;
            const advertiserNames = advertisers.map((adv) => adv.name);
            return (
              <Table.Row key={row.id}>
                <Table.Cell style={{ whiteSpace: "pre-line" }}>
                  {advertisers.length > 0
                    ? advertiserNames.join("\n ")
                    : intl.formatMessage({
                        id: "LABEL_ALL_ADVERTISERS",
                        defaultMessage: "All Advertisers",
                      })}
                </Table.Cell>
                <Table.Cell style={{ whiteSpace: "pre-line" }}>{renderSellers(seller_ids)}</Table.Cell>
                <Table.Cell style={{ whiteSpace: "pre-line" }}>
                  {brands.length > 0
                    ? brands.join("\n ")
                    : intl.formatMessage({ id: "LABEL_ALL_BRANDS", defaultMessage: "All Brands" })}
                </Table.Cell>
                <Table.Cell
                  collapsing
                  textAlign="right"
                >
                  <Link
                    to={`/admin/product-catalog-permissions/edit/${id}`}
                    data-testid="pcp-row-edit"
                  >
                    <Icon
                      name="edit"
                      className="control"
                    />
                  </Link>
                  <Button
                    aria-label={intl.formatMessage({
                      id: "BTN_DELETE",
                      defaultMessage: "Delete",
                    })}
                    data-testid="pcp-row-delete"
                    icon
                    onClick={() => openDeleteDialog(row)}
                    style={{ background: "none" }}
                    type="button"
                  >
                    <Icon
                      name="trash"
                      className="control"
                    />
                  </Button>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
      {!isNil(selectedPermission) && (
        <DeletePermissionModal
          isOpen={showDeleteDialog}
          onClose={closeDeleteDialog}
          permission={selectedPermission}
        />
      )}
    </>
  );
};

export default ProductPermissionsSubgrid;

const AdvertiserPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

const PermissionRowPropType = PropTypes.shape({
  advertisers: PropTypes.arrayOf(AdvertiserPropType).isRequired,
  agency_id: PropTypes.number.isRequired,
  agency_name: PropTypes.string.isRequired,
  brands: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.number.isRequired,
  seller_ids: PropTypes.arrayOf(PropTypes.string).isRequired,
});

ProductPermissionsSubgrid.propTypes = {
  permissionRows: PropTypes.arrayOf(PermissionRowPropType).isRequired,
};
